import { _ as r } from "../internals/export.js";
r({
  target: "Number",
  stat: !0,
  nonConfigurable: !0,
  nonWritable: !0
}, {
  EPSILON: 2220446049250313e-31
});